import React from 'react';
import { LuTrash2, LuPackage, LuCircleCheck, LuChevronDown } from 'react-icons/lu';
import { TRABAJOS_FRECUENTES, sumarTrabajo } from '../../utils/trabajosFrecuentes';
import FotosEquipo from '../servicio/FotosEquipo';

// Un equipo dentro del cierre por N/S (22-oct-2026). Se carga de a uno: cerrado muestra el estado
// (Pendiente / Listo) y se abre solo tocándolo, así no se carga en el equipo equivocado sin querer.
// "Equipo listo" lo marca y pasa al siguiente; todo queda en el borrador del celular.

const INPUT = 'w-full px-3 py-2.5 rounded-xl bg-panel text-ink text-caption font-medium outline-none border border-black/[0.05] dark:border-white/[0.05] placeholder:text-muted';

function Estado({ listo, empezado }) {
    if (listo) return <span className="shrink-0 flex items-center gap-1 text-label font-black text-[color:var(--etapa-listo)]"><LuCircleCheck size={14} /> Listo</span>;
    return <span className="shrink-0 text-label font-black text-brand-amber">{empezado ? 'En carga' : 'Pendiente'}</span>;
}

export default function EquipoCargaCard({ item, numero, abierto, onAbrir, onCambiar, onQuitar, onRepuestos, onListo }) {
    const empezado = !!(item.trabajo.trim() || item.repuestos.length || item.fotoAntes || item.fotoDespues || (item.fotosExtra || []).length);
    const lugar = [item.equipo.sede, item.equipo.direccion].filter(Boolean).join(' · ');

    if (!abierto) {
        return (
            <button type="button" onClick={onAbrir}
                className="w-full p-3 rounded-xl bg-page border border-black/[0.06] dark:border-white/[0.06] flex items-center gap-3 text-left active:scale-[0.99]">
                <span className="w-7 h-7 shrink-0 rounded-full bg-chip text-ink text-label font-black flex items-center justify-center">{numero}</span>
                <span className="flex-1 min-w-0">
                    <span className="block font-black text-body text-ink">{item.serie}</span>
                    <span className="block text-label text-muted truncate">
                        {item.listo && item.trabajo.trim() ? item.trabajo : (item.equipo.ubicacion || lugar || 'Tocá para cargar')}
                    </span>
                </span>
                <Estado listo={item.listo} empezado={empezado} />
                <LuChevronDown size={16} className="shrink-0 text-muted" />
            </button>
        );
    }

    return (
        <div className="p-3 rounded-xl bg-page border-2 border-[color:var(--color-brand-red)]">
            <div className="flex items-start justify-between gap-2 mb-2">
                <div className="min-w-0">
                    <p className="text-label font-bold text-muted">Equipo {numero}</p>
                    <p className="font-black text-body text-ink">{item.serie}</p>
                    <p className="text-label text-muted truncate">{lugar}</p>
                </div>
                <button type="button" onClick={onQuitar} aria-label="Sacar este equipo de la carga"
                    className="w-8 h-8 shrink-0 rounded-lg flex items-center justify-center bg-chip text-muted active:scale-95"><LuTrash2 size={14} /></button>
            </div>
            <div className="flex flex-wrap gap-1.5 mb-2">
                {TRABAJOS_FRECUENTES.map(t => {
                    const on = item.trabajo.split(/\s*[·,]\s*/).includes(t);
                    return (
                        <button key={t} type="button" onClick={() => onCambiar({ trabajo: sumarTrabajo(item.trabajo, t) })} aria-pressed={on}
                            className={`h-8 px-2.5 rounded-full text-label font-bold active:scale-95 ${on ? 'bg-brand-red text-white' : 'bg-chip text-secondary'}`}>{t}</button>
                    );
                })}
            </div>
            <textarea value={item.trabajo} onChange={e => onCambiar({ trabajo: e.target.value })} rows={2}
                placeholder="Qué se hizo (tocá arriba o escribilo)" className={INPUT + ' mb-2'} />
            <button type="button" onClick={onRepuestos}
                className="w-full mb-2 h-9 rounded-lg text-label font-bold bg-chip text-secondary active:scale-95 flex items-center justify-center gap-1.5">
                <LuPackage size={13} />
                {item.repuestos.length ? item.repuestos.map(r => `${r.cantidad}x ${r.nombre}`).join(', ') : 'Repuestos usados'}
            </button>
            <FotosEquipo fotoAntes={item.fotoAntes} fotoDespues={item.fotoDespues} fotosExtra={item.fotosExtra} fotosRotulos={item.fotosRotulos}
                onChange={onCambiar} />
            <button type="button" onClick={onListo} disabled={!item.trabajo.trim()}
                className="w-full mt-3 h-11 rounded-xl font-black text-label uppercase bg-ink text-page active:scale-95 disabled:opacity-40 flex items-center justify-center gap-1.5">
                <LuCircleCheck size={15} /> {item.trabajo.trim() ? 'Equipo listo' : 'Falta: qué se hizo'}
            </button>
        </div>
    );
}
